import { makeAutoObservable } from 'mobx';
import {
  LiveBroadcast,
  Presentation
} from './presentation-config-aggregate-types/presentation-config-aggregate-types';
import TimelineEntity from './time-line-entity/timeline-entity';
import SequenceEntity from './sequence-entity/sequence-entity';

class PresentationConfigAggregate {

  private timeline: TimelineEntity;

  constructor () {
    makeAutoObservable(this);
  }

  public init = (fromDTO: Presentation = {} as Presentation): void => {
    this.deserialize(fromDTO);
  };

  public getTimeLine = (): TimelineEntity => {
    return this.timeline;
  };

  public getAllWorkingSequence = (): SequenceEntity => {
    return this.timeline.getSequences()[0];
  };

  public isLiveBroadcast = (): LiveBroadcast | void => {
    return this.timeline.getSequences()[0]?.isLiveBroadcast();
  };

  private deserialize = ({ project }: Presentation): void => {
    this.timeline = new TimelineEntity(project.timeline);
  };
}

export default PresentationConfigAggregate;
